import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/appstore.png")